import './Offcanvas.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Button } from './Button';

export type OffcanvasHeaderProps = b2x.OffcanvasHeaderProps;

export const OffcanvasHeader = (props: OffcanvasHeaderProps) => (
  <b2x.OffcanvasHeader {...props} customComponent={CustomOffcanvasHeader} />
);

const CustomOffcanvasHeader = ({ children, className, smallPadding, title }: OffcanvasHeaderProps) => {
  const { id } = b2x.useModalContext();
  return (
    <div className={classnames('offcanvas-header-wrapper py-3', smallPadding ? 'px-3' : 'px-5')}>
      <div className={classnames('offcanvas-header border-bottom p-0', className)}>
        {(title || children) && (
          <h5 className="offcanvas-title text-uppercase h3" id={`${id}-label`}>
            {title}
            {children}
          </h5>
        )}
        <Button
          aria-label="Close"
          data-bs-dismiss="offcanvas"
          iconEnd={{ name: 'close' }}
          type="button"
          variant="blank"
        />
      </div>
    </div>
  );
};
